import React, { useState, useEffect } from 'react';
import AIAnalysis from './AIAnalysis';
import LoadingSpinner from './LoadingSpinner';
import ErrorMessage from './ErrorMessage';
import { getApiUrl } from '../App';
import { getToken } from '../context/AuthContext';

const AIAnalysisTab = ({ symbol }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAIAnalysis = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(getApiUrl(`/api/ai-analysis/${symbol}`), {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        if (!response.ok) {
          throw new Error('Failed to fetch AI analysis');
        }
        const analysisData = await response.json();
        setData(analysisData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAIAnalysis();
  }, [symbol]);

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message={error} />;
  if (!data) return null;

  return <AIAnalysis data={data} />;
};

export default AIAnalysisTab; 